module.exports = __webpack_public_path__ + "static/index/img/baikal-304.7ffa3564.jpg";